import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import {
  Stack, 
  Container
} from '@mui/material';

import SignatureButton from '../components/signature-button';
import OTPInput from '../components/otp-input';
import TokenChallenge from '../components/token-challenge';
import BatchClosingStatus, { useBatchClosing } from '../components/batch-closing';
import { EntityContext } from '../entity';

// Lote do usuário logado: só e-mail (o backend barra whatsapp aqui) e sem estado do token.
function BatchSignatureConfirmationPage() {

    const { batchKey } = useParams();

    const [otp, setOtp] = useState('');
    const [error, setError] = useState(null);
    // a rota de estado só conhece a chave do lote de endosso: aqui a consulta ao montar dá 404 e a tela segue como hoje
    const { getBatchEndorsementState } = useContext(EntityContext);
    const closing = useBatchClosing(batchKey, getBatchEndorsementState);

  return (
    <>
    
      <Helmet>
          <title> Confirmar Assinatura </title>
      </Helmet>

      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3 }, py: { xs: 4, sm: 6 } }}>

        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={{ xs: 3, sm: 4, md: 5 }}
          sx={{
            minHeight: { xs: 'calc(100vh - 200px)', sm: 'auto' },
            py: { xs: 4, sm: 6, md: 12 }
          }}
        >
            {closing.phase === 'open' ? (
              <TokenChallenge channel="email" error={error}>
                <OTPInput value={otp} onChange={setOtp} length={6} />
                <SignatureButton otp={otp} batchKey={batchKey} isEndorsement={false} onError={setError} onSigned={closing.onSigned}/>
              </TokenChallenge>
            ) : (
              <BatchClosingStatus {...closing} />
            )}
        </Stack>
        </Container>
  </> 
  );
}

export default BatchSignatureConfirmationPage;
